import BaseTableController from './base_table_controller';

// dp_id 2293 — data_grid: { rows: [{ nace_sector }] }
export default class extends BaseTableController {
  static values = { naceSectorOptions: Array };

  searchableFields = ['nace_sector'];

  connect() {
    const rows = this.initialDataValue?.rows;
    this.rows =
      Array.isArray(rows) && rows.length > 0
        ? rows.map((r) => ({ nace_sector: r.nace_sector ?? '' }))
        : [this.emptyRow()];
    this.renderRows();
    this.syncHiddenField();
  }

  emptyRow() {
    return { nace_sector: '' };
  }

  updateField(event) {
    const el = event.currentTarget;
    const index = parseInt(el.dataset.rowIndex, 10);
    this.rows[index].nace_sector = el.value;
    // Re-render so other dropdowns exclude the newly selected sector
    this.renderRows();
    this.syncHiddenField();
  }

  buildRow(row, index) {
    const tr = document.createElement('tr');

    const usedValues = new Set(
      this.rows.filter((r, i) => i !== index && r.nace_sector).map((r) => r.nace_sector)
    );
    const availableOptions = this.naceSectorOptionsValue.filter((opt) => !usedValues.has(opt));

    tr.appendChild(
      this.buildSelectCell(row, index, 'nace_sector', availableOptions, { fullWidth: true })
    );
    tr.appendChild(this.buildRemoveButton(index));

    return tr;
  }
}
